export default __webpack_public_path__ + "static/property-img-114053c20ffeb440a117c224aaaf0b30.jpg";